// removed by extract-text-webpack-plugin
module.exports = {"root":"PopinInfoContainer-module-root-1H1Gq","popin-bg":"PopinInfoContainer-module-popin-bg-3Is2F","popinBg":"PopinInfoContainer-module-popin-bg-3Is2F","content":"PopinInfoContainer-module-content-1ISWT","button-question":"PopinInfoContainer-module-button-question-1-lQt","buttonQuestion":"PopinInfoContainer-module-button-question-1-lQt","btn":"PopinInfoContainer-module-btn-1sWAT","icon-close":"PopinInfoContainer-module-icon-close-3Xm5W","iconClose":"PopinInfoContainer-module-icon-close-3Xm5W"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PopinInfoContainer/PopinInfoContainer.module.scss
// module id = 1034
// module chunks = 0